import SalesTargetsListing from './SalesTargetsListing';

export default SalesTargetsListing;
